import { MessageBotNodesEnum } from "@lib/types/MessageBot";
import { NodeProps } from "@xyflow/react";
import ActionNode from "./ActionNode";
import RootNode from "./RootNode";
import PopupNode from "./PopupNode";

const Nodes: Record<MessageBotNodesEnum, React.FC<NodeProps>> = {
  [MessageBotNodesEnum.ACTION]: ActionNode,
  [MessageBotNodesEnum.ROOT]: RootNode,
  [MessageBotNodesEnum.POPUP]: PopupNode,
};

export default Nodes;
